import _ from 'lodash';

export default function reduceSpeakers(state, action) {
    if (!state) {
        state = {
            loaded: false,
            listed: [],
            indexed: {},
            byProgramItem: {},
        };
    }

    var original = state;

    switch (action.type) {
        case 'EVENT_SPEAKERS_LOADED':
            state = Object.assign({}, state, {
                loaded: true,
                indexed: { ...state.indexed },
            });
            action.speakers.forEach((speaker) => {
                if (!state.indexed[speaker.id]) {
                    state.indexed[speaker.id] = {
                        ...speaker,
                        roles: speaker.roles || [],
                    };
                } else {
                    state.indexed[speaker.id] = {
                        ...state.indexed[speaker.id],
                        program_item_ids: _.uniq([...state.indexed[speaker.id].program_item_ids, ...speaker.program_item_ids]),
                        roles: _([...(state.indexed[speaker.id].roles || []), speaker.role])
                            .uniq()
                            .compact()
                            .value(),
                    };
                }
            });
            state.listed = Object.values(state.indexed);
            break;
        case 'EVENT_PROGRAM_LOADED':
            state = reduceSpeakers(
                state,
                app.actions.speakers.loadEventSpeakers(
                    action.eventId,
                    _(action.program)
                        .map((program) => program.speakers)
                        .flatten()
                        .filter((speaker) => Boolean(speaker.id))
                        .map((speaker) => ({
                            ...speaker,
                            program_item_ids: [speaker.program_id],
                        }))
                        .value()
                )
            );
            break;
    }

    if (original != state) {
        state.byProgramItem = {};
        _(state.listed).each((speaker) => {
            _(speaker.program_item_ids).each((id) => {
                if (!state.byProgramItem[id]) state.byProgramItem[id] = [];
                state.byProgramItem[id].push(speaker);
            });
        });
    }

    return state;
}
